import { FC } from 'react';

import BaseInput, { SeturInputProps } from '@components/Input';
import { useHeight } from '@components/utils/hooks/useSize';

const Input: FC<SeturInputProps> = (p) => {
  const height = useHeight();
  return <BaseInput {...p} height={height} />;
};

export default Input;
